export default {
  newDesign: true,
  parameters: {
    landing_id: "EnfwdFCUK",
    segment: 3,
    success_page: 'success_long_new_design',
  },
  title: "Answer 5 questions to receive an invitation to a FREE ONLINE ANIMATION COURSE! | Kodland",
  downtimeUrl: "https://www.kodland.org/",
  startPage: {
    title:
      "Answer 5 questions to receive an invitation to a FREE ONLINE ANIMATION LESSON!",
    subtitle:
      "Your child will try their hand at digital creativity, animation, illustration, 3D modelling, design.",
    image: {
      url: "/welcome/uk_fwd_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/uk_fwd_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Click here to register 🚀 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Thank you for your interest in Kodland. Our online courses are designed for children aged 8 to 17.",
    subtitle: "Please note that our courses require a keyboard and mouse; therefore, phones, tablets, and devices without these features are not compatible.<br>If you do have a laptop, please resubmit the form via this link <a target=\"_blank\" href=\"https://mrqz.me/66c7170aca95fe0026c5a69c?roistat_visit=9376\">this link</a>, or contact us at +447700182949💙",
  },
  quizRotateBySteps: {
    1: {
      question: "How much time does your child spend on electronic devices per day?",
      answers: [
        "😍 1 hour",
        "🙂 2-3 hours",
        "😔 More than 4 hours",
      ],
    },
    2: {
      question: "How would you describe your child's personality?",
      subtitle: "Your answer helps us choose the right teaching methodology",
      answers: [
        "🥳 Active, talks a lot",
        "😌 Shy",
        "🤩 Dreamer",
        "🤫 Quiet, spends a lot of time alone",
        "🤔 Not sure what they want",
        "❓ Surprise me (You'll find out in class)"
      ],
    },
    3: {
      question: "How would you rate your child's motivation to learn?",
      answers: [
        "😍 High",
        "😌 Low",
        "🤔 Average",
      ],
    },
    4: {
      title: "How old is your child?",
      type: "age",
      button: "",
    },
    5: {
      question: "Do you have a computer or laptop for studying?",
      answers: [
        "✔️ Yes",
        {
          answer: "❌ No",
          stopAnswer: true,
        },
      ],
    },
    6: {
      title: "🎉 Just one more step!",
      typeInfo: "congrats",
      subtitle:
        "Help your child explore their creative side with programming and digital design.<br>🌟 More than 200,000 kids are already creating and learning with us.",
      button: "📅 Book a free class!",
    },
    7: {
      title: "🎉 Register for a free trial class",
      type: "one-page-contacts",
      subtitle: "Your child will create a mini-game in the first lesson. And you can join too!",
      button: "✨ Perfect! Just one more step.",
    },
    8: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    9: {
      title:
        "Check out this information to complete the registration ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Please ensure you have a working computer or laptop available for the lesson. It’s also important that you accompany your child during the class. Each session is personalized and tailored to your child's needs.",
      button: "What else?",
    },
    10: {
      title: "Before the trial, check your email and WhatsApp for updates 📞",
      typeInfo: "whatsapp",
      subtitle:
        "We'll send you a reminder 24 hours before the class and will request confirmation of your attendance 2 hours prior to the start time. Staying in touch is essential to avoid class cancellation.",
      button: "Great!",
    },
    11: {
      title: "The lesson will take place on our platform 💻",
      typeInfo: "classroom",
      subtitle:
        "You'll get a link and a unique code via WhatsApp and email. Just click the link, it will take you straight to the lesson. No extra apps, no downloads.",
      button: "Got it ✅",
    }
  },
};
